import { createStore } from 'vuex'

// old local storage
// const store = createStore({
//   state: {
//     authString: JSON.parse(localStorage.getItem('authString')) || [] // Initialize with the data from local storage if available
//   },
//   mutations: {
//     addAuthString: function(state, payload) {
//       state.authString.push(payload);
//       localStorage.setItem('authString', JSON.stringify(state.authString)); // Save to local storage after mutation
//     }
//   },
//   getters: {
//     getAuthString: function(state) {
//       return state.authString;
//     },
//     removeAuthString: function(state) {
//       state.authString = [];
//       localStorage.removeItem('authString'); // Clear from local storage after mutation
//     }
//   },
// })

const store = createStore({
  state: {
    authString: JSON.parse(getCookie('authString') || '[]') // Initialize with the data from cookies if available
  },
  mutations: {
    addAuthString: function (state, payload) {
      state.authString.push(payload);
      setCookie('authString', JSON.stringify(state.authString), 24); // Save to cookies with an expiration of 24 hours
    }
  },
  getters: {
    getAuthString: function (state) {
      return state.authString;
    },
    removeAuthString: function (state) {
      state.authString = [];
      deleteCookie('authString'); // Clear from cookies
    }
  },
});

// Helper functions for managing cookies
function setCookie(name, value, hours) {
  const expires = hours
    ? `; expires=${new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString()}`
    : '';
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  const sameSite = '; sameSite=Lax';
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}${secure}${sameSite}; path=/`;
}


function getCookie(name) {
  const cookieArr = document.cookie.split('; ');
  for (let cookie of cookieArr) {
    // Split only at the first "=" to handle "=" in the cookie value
    const [key, ...valueParts] = cookie.split('=');
    const value = valueParts.join('='); // Rejoin in case the value contains "="
    if (key.trim() === name) {
      try {
        const decodedValue = decodeURIComponent(value); // Decode URI-encoded values safely
        if (decodedValue === null || decodedValue === undefined) {
          console.error(`Cookie value for ${name} is null or undefined`);
          return null;
        }
        return decodedValue;
      } catch (error) {
        console.error(`Error decoding cookie value for ${name}:`, error);
        return null;
      }
    }
  }
  console.log(`Cookie ${name} not found`);
  return null; // Return null if the cookie is not found
}



function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

  export default store